import * as React from 'react'
import { Link as RRLink } from 'react-router-dom'
import styled from 'styled-components'
import { Box } from '@ally/metronome-ui'
import { AdobeTile } from '../../../types'
import AdobeIcon from '../AdobeIcon'

interface ComponentProps {
  tileData: AdobeTile
}

const StyledAnchor = styled(RRLink)(({ theme }) => theme.buttons.link)

const StyledLink = styled(StyledAnchor)`
  ${({ theme: { media } }): string => `
    text-decoration: none;
    white-space: normal;

    ${media.down('sm')} {
      max-width: 100px;
    }
  `};
`

const MdSmTile: React.FC<ComponentProps> = ({ tileData }) => {
  return (
    <StyledLink to={tileData.ctaHref}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="space-between"
        justifyItems="center"
        marginLeft="xs"
        marginRight="xs"
      >
        <AdobeIcon tileData={tileData} alignment="center" />
        <Box
          size="md"
          mt="xs"
          aria-label={tileData.ariaText}
          textAlign="center"
        >
          {tileData.title}
        </Box>
      </Box>
    </StyledLink>
  )
}

export default MdSmTile
